export default {
  columns: {
    offerName: "Nom de l'offre",
    type: 'Type',
    status: 'Statut',
    active: 'Actif',
    inactive: 'Inactif',
    details: 'Détails',
    schedule: 'Planification',
    startDate: 'Date de début',
    images: 'Image',
  },
  actions: {
    edit: 'Modifier',
    rename: 'Renommer',
    delete: 'Supprimer',
    set_active: 'Activer',
    set_inactive: 'Désactiver',
    cancel: 'Annuler',
    confirm: 'Confirmer',
    activate: 'Remplacer & Activer',
    manage_images: "Modifier l'image",
  },
  toasts: {
    offer_enabled: "{{offer}} est maintenant l'offre active pour {{for}}",
    offer_disabled: '{{offer}} définie comme inactive.',
    update_failed: "La mise à jour de l'offre a échoué.",
    successfully_deleted: "L'offre a été supprimée avec succès",
    delete_failed: "La suppression de l'offre a échoué",
  },
  title: 'Gérer toutes les offres',
  popups: {
    delete: {
      title: 'Voulez-vous vraiment supprimer cette offre ?',
    },
    toggle: {
      title_overlapping_is_not_allowed: "Le remplacement des offres principales n'est pas autorisé",
      title: "Remplacer l'offre active pour cette période ?",
      description:
        "Vous activez {{offer}} le {{weekday}}{{between}}. Cela désactivera l'offre active actuelle {{currentOffer}} pour la même période.",
      between: ', entre {{start}}-{{end}}',
    },
  },
};
